import React from 'react';

const TnCText = ({
  styles = {},
}) => (
  <p className="text-center text-light-grey" style={{ fontSize: 10, ...styles }}>
    By purchasing, you agree to our <a className="text-light-grey" href="/terms/" target="_blank">Terms</a> &amp; <a className="text-light-grey" href="/privacy/" target="_blank">Privacy</a>
  </p>
);

export default TnCText;



// WEBPACK FOOTER //
// ./src/payments/views/finalize/TnCText.js